import { PropsWithChildren } from 'lib-shared-types-utils';

import { AppLink } from 'components/appLink';

export type UserLinkProps = {
  /** The id of the user used to link to the contact page */
  userId: string;
} & PropsWithChildren;

export const UserLink = ({ userId, children }: UserLinkProps): JSX.Element => {
  return (
    <AppLink path={`/contacts/user/:id`} params={{ path: { id: userId } }}>
      {children}
    </AppLink>
  );
};
